<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-briefcase" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Ministries, Departments and Parastatals</h4>
              <small style="opacity: .8;">
                <span v-if="ministries.data && ministries.data.length">{{ ministries.data.length }} MDAs registered</span>
                <span v-else>Manage MDAs and establishments</span>
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- Actions Card -->
        <div class="card action-card shadow mb-4">
          <div class="card-body py-3 px-4 d-flex flex-wrap align-items-center" style="gap: 8px;">
            <button class="btn btn-submit" @click="show = !show">
              <i class="fe fe-plus mr-1"></i> Add MDA
            </button>
            <button class="btn btn-outline-secondary" @click="getStats">
              <i class="fe fe-bar-chart-2 mr-1"></i> Get Statistics
            </button>
            <button class="btn btn-outline-secondary ml-auto">
              <download-excel :data="stats" :fields="json_fields" :escapeCsv="false" name="establishments.xls">
                <i class="fe fe-download mr-1"></i> Export Data
              </download-excel>
            </button>
          </div>
        </div>

        <!-- Add / Edit Form -->
        <div class="card table-card shadow mb-4" v-show="show">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-plus" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">
                {{ edit ? 'Edit MDA' : 'Add New MDA' }}
              </p>
            </div>
          </div>
          <div class="card-body">
            <div class="form-row col-md-12">
              <div class="form-group col-md-4" v-if="selector == 'ministry'">
                <label class="info-label d-block mb-1">Name of MDA</label>
                <input type="text" required class="form-control" placeholder="Name of MDA" v-model="register.ministry" />
              </div>
              <div class="form-group col-md-4" v-if="selector == 'ministry'">
                <label class="info-label d-block mb-1">Type</label>
                <select class="form-control" required v-model="register.type">
                  <option value="public">Government Owned</option>
                  <option value="private">Private Owned</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">HMO</label>
                <select class="form-control" v-model="register.hmo_id">
                  <option v-for="org in tpas" v-bind:key="org.id" :value="org.id">{{ org.organization_name }}</option>
                </select>
              </div>
            </div>
            <button @click="registerMDA" class="btn btn-submit px-4">
              <i class="fe fe-save mr-1"></i> {{ edit ? 'Update' : 'Submit' }}
            </button>
          </div>
        </div>

        <!-- Table Card -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-list text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">All MDAs</h6>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">SN</th>
                  <th class="table-th">MDA</th>
                  <th class="table-th">Type</th>
                  <th class="table-th">HMO</th>
                  <th class="table-th">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="(mda, index) in ministries.data" v-bind:key="mda.id">
                  <td class="text-muted" style="font-size:.85rem;">{{ index + 1 }}</td>
                  <td class="font-weight-bold">{{ mda.name }}</td>
                  <td>
                    <span class="badge badge-soft-secondary" style="font-size:.75rem;">{{ mda.type }}</span>
                  </td>
                  <td>
                    <span v-if="mda.hmo" style="font-size:.85rem;">{{ mda.hmo.organization_name }}</span>
                    <span v-else class="text-muted" style="font-size:.82rem;">&mdash;</span>
                  </td>
                  <td>
                    <div class="d-flex flex-wrap" style="gap:4px;">
                      <router-link :to="{ path: '/mda/' + mda.id }">
                        <button class="btn btn-sm btn-outline-secondary"><i class="fe fe-eye"></i> View</button>
                      </router-link>
                      <button type="button" @click="startEdit(mda)" class="btn btn-sm btn-outline-primary">
                        <i class="fe fe-edit"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" @click="disableMDA(mda)" v-if="mda.deleted_at == null">
                        Disable
                      </button>
                      <button class="btn btn-sm btn-outline-success" @click="enableMDA(mda)" v-else>
                        Enable
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-body pt-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              @input="getDepts(currentPage ? currentPage : 1)"
            ></b-pagination>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      stats: "",
      type: "",
      tpas: "",
      ministries: "",
      departments: "",
      parastatals: "",
      current_page: 1,
      edit: false,
      show: false,
      selector: "ministry",
      isLoading: false,
      fullPage: true,
      agency_id: "",
      provider_id: "",
      ministry_id: "",
      perPage: 15,
      currentPage: 1,
      rows: "1",
      register: {
        ministry: "",
        department: "",
        type: "",
        hmo_id: "",
      },
      json_fields: {
        Name: "name",
        "Total Principal ": "enrollees_count",
        "Male Total": "male_count",
        "female Total": "female_count",
        "Dependent Count": "dependants_count",
        Total: "total",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  mounted() {
    this.getDepts();
  },

  methods: {
    getTPAs() {
      this.user = JSON.parse(localStorage.getItem("user"));

      this.axios
        .get(`/api/v1/auth/orgenrollment`, {
          params: {
            agency_id: 90,
          },
        })
        .then((response) => {
          this.tpas = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getDepts(currentPage) {
      this.axios
        .get("/api/v1/auth/ministries/90?page=" + currentPage)
        .then((response) => {
          this.ministries = response.data;
          this.rows = response.data.meta.total;
          this.json_data = this.ministries;

          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    registerMDA() {
      this.isLoading = true;
      if (this.edit == false && this.selector == "ministry") {
        this.axios
          .post("/api/v1/auth/ministry", {
            agency_id: 90,
            name: this.register.ministry,
            type: this.register.type,
            hmo_id: this.register.hmo_id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.getDepts(this.currentPage);
            this.clearIt();
            this.$toasted.info("MDA Added", {
              position: "top-center",
              duration: 5000,
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Error", {
              position: "top-left",
              duration: 5000,
            });
          });
      }
      if (this.edit == true) {
        this.axios
          .put("/api/v1/auth/ministry", {
            id: this.register.id,
            name: this.register.ministry,
            type: this.register.type,
            hmo_id: this.register.hmo_id,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.edit = false;
            this.getDepts(this.currentPage);
            this.clearIt();
            this.$toasted.success("Updated Successfully", {
              position: "top-left",
              duration: 5000,
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Error", {
              position: "top-left",
              duration: 5000,
            });
          });
      }
    },
    getStats() {
      this.isLoading = true;

      this.axios
        .get(`/api/v1/auth/establishment/stats`, {
          params: {
            agency_id: "90",
          },
        })
        .then((response) => {
          this.stats = response.data.data;

          this.stats = response.data.data.filter((item) => item.total > 0);

          this.$toasted.info("Fetched Successfully!", {
            position: "top-left",
            duration: 5000,
          });
          console.log(response);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    startEdit(mda) {
      this.edit = true;
      this.show = true;
      this.selector = "ministry";
      this.register.id = mda.id;
      this.register.ministry = mda.name;
      this.register.type = mda.type;
      this.register.hmo_id = mda.hmo_id;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    enableMDA(mda) {
      if (confirm("Are you sure you want to enable this MDA?")) {
        this.isLoading = true;
        this.axios
          .put(`/api/v1/auth/ministry/restore/${mda.id}`)
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.getDepts(this.currentPage);
            this.$toasted.success("MDA Enabled Successfully", {
              position: "top-left",
              duration: 5000,
            });
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error.response);
            this.$toasted.error("Error", {
              position: "top-left",
              duration: 5000,
            });
          });
      }
    },

    disableMDA(mda) {
      if (confirm("Are you sure you want to disable this MDA?")) {
        this.isLoading = true;
        this.axios
          .delete(`/api/v1/auth/ministry/${mda.id}`)
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.getDepts(this.currentPage);
            this.$toasted.success("MDA Disabled Successfully", {
              position: "top-left",
              duration: 5000,
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Error", {
              position: "top-left",
              duration: 5000,
            });
          });
      }
    },

    clearIt() {
      this.register.ministry = "";
      this.register.type = "";
      this.register.hmo_id = "";
    },
  },
  created() {
    this.getTPAs();
  },
};
</script>
